import { render, staticRenderFns } from "./contato-component.vue?vue&type=template&id=49ddd45e&"
import script from "./contato-component.vue?vue&type=script&lang=ts&"
export * from "./contato-component.vue?vue&type=script&lang=ts&"
import style0 from "./contato-component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49ddd45e')) {
      api.createRecord('49ddd45e', component.options)
    } else {
      api.reload('49ddd45e', component.options)
    }
    module.hot.accept("./contato-component.vue?vue&type=template&id=49ddd45e&", function () {
      api.rerender('49ddd45e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/component/contato-component.vue"
export default component.exports